<template>
  <div>
    <div id="contact-form" class="contact-form">
      <h2 class="label-input margin-bottom-2">{{ $t('label.formContact.sendQuestions') }}</h2>
      <form class="form" @submit="submitForm">
        <p class="label-input margin-bottom-2">Asunto</p>
        <input required name="name" v-model="subject" type="text" autocomplete="off" />
        <p class="label-input">Escribe aquí tu pregunta</p>
        <textarea name="text" v-model="message" rows="4"></textarea>
        <button class="button">Enviar</button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormContact",

  data() {
    return {
      subject: null,
      message: null
    };
  },

  methods: {
    submitForm(event) {
      const subject = this.subject;
      const message = this.message;

      window.open(
        `mailto:escuelanamsan@gmail.com?subject=${subject}&body=${message}`
      );
      event.preventDefault();

      return true;
    }
  }
};
</script>

<style>
.margin-bottom-2 {
  margin-bottom: 10px;
}

.label-input {
  text-align: left;
  margin: inherit;
  margin-top: 10px;
}

.no-margin {
  margin: 0;
  margin-bottom: 20px;
}

.contact-form {
  font-family: 16px;
  margin: 0 auto;
  width: 100%;
}

.contact-form .form {
  display: flex;
  flex-direction: column;
  font-size: 16px;
}

.contact-form_title {
  color: #333;
  text-align: left;
  font-size: 28px;
}

.contact-form input[type="text"],
.contact-form textarea {
  border: solid 1px #e8e8e8;
  text-align: center;
  outline: none;
  width: 100%;
  height: 14px;
}

.contact-form textarea {
  resize: none;
  margin-top: 20px;
  height: auto;
}

.contact-form .button {
  background: #485cdf;
  border: solid 1px #485cdf;
  color: white;
  cursor: pointer;
  width: 100%;
  margin-top: 20px;
  text-align: center;
  text-transform: uppercase;
}

.contact-form .button:hover {
  background: #485cdf;
  border: solid 1px #485cdf;
}

.contact-form input[type="text"],
.contact-form textarea,
.contact-form .button {
  font-size: 15px;
  border-radius: 3px;
}
</style>
